import * as style from './styles.css';
import { clsx } from 'clsx';
import { Button, useDeviceType } from '@cian/ui-kit';
import { EModalSource } from 'shared/common/types/modal';
import { getHowItWork } from 'shared/landingSeller/constants/howItWorks';
import { IApplicationContext } from '../../../common/types/applicationContext';

export const HowItWorks: React.FC<{
  onOpenModal: (EModalSource: EModalSource) => void;
  context: IApplicationContext['custom'];
  userId?: number;
  source?: string;
  agentCommissionRef?: React.RefObject<HTMLDivElement | null>;
}> = ({ onOpenModal, agentCommissionRef, context }) => {
  const device = useDeviceType();
  const items = getHowItWork(context);

  return (
    <div className={clsx(style['container'], style[device])}>
      <div className={style['title']}>Пройдём с вами весь путь</div>
      <div className={style['list']}>
        {items.map(({ id, title, description, imageClass, button }) => (
          <div key={id} className={style['item']}>
            <div className={style['item-textblock']}>
              <div className={style['item-id']}>{id}</div>
              <div className={style['item-title']}>{title}</div>
              <div className={style['item-descr']}>{description}</div>
              {button && <div className={style['item-button']}>{button}</div>}
            </div>
            <div className={clsx(style['item-image'], style[imageClass])} />
          </div>
        ))}
      </div>
      <div ref={agentCommissionRef} className={style['notice']}>
        <div className={style['notice-title']}>Без предоплат и&nbsp;скрытых комиссий</div>
        <div className={style['notice-descr']}>Оплата только агенту и только после сделки</div>
      </div>
      <div className={style['button']}>
        <Button
          size="L"
          fullWidth={device !== 'desktop' && device !== 'tablet'}
          onClick={() => onOpenModal(EModalSource.Consultation)}
        >
          Расскажите ещё подробнее
        </Button>
      </div>
    </div>
  );
};
